import { isString } from 'lodash';
import { Component, ReactElement, ReactNode } from 'react';
import ArrowPointLeftIcon from '@shared/assets/icons/v2/arrow-point-left.svg';
import DotsIcon from '@shared/assets/icons/v2/dots.svg';
import { Text } from '@shared/components/Text';
import { MBImageURISource } from '@shared/components/image';
import { MBSeparator } from '@shared/components/list/separator';
import { MBNavigationHeaderButton } from './headerButton';
import classNames from './NavHeader.module.css';

export interface MobileNavHeaderProps {
  title?: ReactNode;
  leftIcon?: MBImageURISource;
  rightIcon?: MBImageURISource;
  separator?: boolean;
  rightButton?: ReactElement;
  onPressLeft?(node: Component): void;
  onPressRight?(node: Component): void;
}

export function NavHeader({
  title,
  onPressLeft,
  onPressRight,
  leftIcon = ArrowPointLeftIcon,
  rightIcon = DotsIcon,
  separator = true,
  rightButton,
}: MobileNavHeaderProps) {
  return (
    <>
      <div className={classNames.navHeader}>
        {!!onPressLeft && (
          <div className={classNames.left}>
            <MBNavigationHeaderButton icon={leftIcon} onPress={onPressLeft} />
          </div>
        )}
        {isString(title) && (
          <div className={classNames.title}>
            <Text size="h4" numberOfLines={1}>
              {title}
            </Text>
          </div>
        )}
        {!isString(title) && !!title && <div className={classNames.title}>{title}</div>}
        {rightButton && <div className={classNames.right}>{rightButton}</div>}
        {!rightButton && !!onPressRight && (
          <div className={classNames.right}>
            <MBNavigationHeaderButton icon={rightIcon} onPress={onPressRight} />
          </div>
        )}
      </div>
      {!!separator && <MBSeparator />}
    </>
  );
}
